/**
 * Created by mauget on 5/4/16.
 */

import Immutable    from 'immutable';
import restService  from 'RestService.js';
import constants    from 'Constants.js';
import undoService from 'UndoService';
import eventBus  from 'EventBus.js';
import textConstants        from 'TextConstants';
import NotificationService from 'NotificationService.js';
import listService from 'ListService.js';
import zLib                 from 'util/ZLib';
import formulaService from './xml/FormulaService';
import util from './util/Util';
import xjService from './xml/XJService';
//===========================================================================================
// This service creates a new form on the host.
//===========================================================================================
class FormAddService {

    constructor() {

        // Prototype form passed to /App/Add
        // Compressed to binary and then base 64 encoded. Don't introduce whitespace, else it breaks.
        // That's right, the margins do not form part of the literal,
        this._formXML = `H4sIAAAAAAAA/3jajVfbbts4EP0Vga8NNraTzbZAFEB2mkuRNEbsNI8LWqJkrmlSIKm4yUO/fYc3mVJkwHwRPRzOnJk5Q9KXN0JuE1qkCCUcb0mKeMMYSqrGyMY3gle7LLsbqSz7sb7NsuvrxZf5/WvxkqKkEPkvIhUVPEUjlLy187/G6OpyLkVNpKZEJaLRihZkJpiQKSJ2oETRDzKXRBGdorxRWmxRUkrA8CwaXsyE5GAwRVo2xC8sYAeAukCJppq1WHPCNZF3QtIPwTVmYY+JZwa2YNECLCiuwIy6lbR4pYVep2jyN0qoemyYpg+YVykqMVOkq3pHaLXWTnfntn0dGXM1TdE/k+D/lwk233tf+20XRtfCb61ruiWQkxSdwVIueEnldirFThE5Y0KRYIKqLM+JUnTFItkLt9EXQVLjiixFvcilYCwWfi9LkoMXLjhIpGYtgCrKAEBQa1yIXdiq1mL3E+A+lQ8i31BevSiTQLfYcAoWa/qbMOckTrCN0lf54iLPy9K5ajM4QqdXlwuNNVH+a6mHGfsXm0q+YdaYsgInMTO6p0H5afUfxNJO7LaX813xI8uy5mGTZQ8/xzB9Xn2ZP85mAtip32swVUnR1IHac8Cb9Li5wvnGKBnGWeB/TFTTyv5C0fL9FuSZArreF62WFaIE2zJdE5WbPlpjtXT89OleCVlAaZ393I4gBDqfJEowWnhSe60bO1Dy8eS0Rn4ZGhISCa1WYI5PkrGRi9quM1JqpygxVzWWhOfvYB8lW6xsibhAiVgxWmEt5PsjQAb0BrHDv6CMGOsetds105IZFY1X3zleRbzrEDxujF7OFvrd5MJ1iQ9j2s/6aPTtm4nXrkZ8AY4VBTWdaSMVbElrC6eNUe9ttdBrSZjAzn2Aay1nEDycUCZVXrIkv8GT5ZqjVjsBshnC+M8RjOuQzBj024HDUvfng8QvSInhLArMb3ct12TrdnTJyyjfmAB8Es9guJ4D0k9j0o3ssFVkgdyQLTugYI3WghtD12LHe1vcoi9i3ah1EE2rSDsc6gzLCuqHTc0cV+eirilXJ8lkdAKkZ8VJ4vs70eCxpzSehOVIzYA2Nok8QtsGHyUlxOGSMhx6K27vJjDFepk9O4sz9fQ2nFyHc1rdSsgBsLPnzxXgYGmexc6Kx70dQT7ZQ6S8bnTHUgAZ16CXCLO8JQVttofXO2H04FunA3mJTsNwK3fc9Ov2tU+FUIde2kKwEaYB7/pztZ29I+hiK30A5flencK7guYRMfq6o8+mbbKOgBBVcn8dQL+AN8LgIKJHBeL5vdwfjPv3xp50cKh2HcBRYm6DHgdaxz2qj+34XK5IJZRs3yq90nRs9yrZ4nFPvfPW0xDP49IN8Nil9VDDB+QDZ1hQGQiqxX6wwc2RfAztWkNDZ4Gt5YCVoZ55BhgNvJMn4eiz92s1iLmHNbonLPHMQ9HSInoC9bU7TW7uKXs3XV2+Crkpmdj5/xLu9bXzwu6t1Xk4+CsPbruKmIeVOzz8c8JouBcjXIOn5iLWa/N9Fsz+Pg1eYWr+yFz9D5FmWxNVZ4KrzwwAAA==`;
    }

    get defaultForm() { 
        this.setDefaultFont();
        return this._formXML.replace(/\s/g,''); 
    }

    decompressForm(){
        let decompressedForm = zLib.decompressForm( this._formXML );
        decompressedForm = util.minifyXMLString(decompressedForm);

        const
            formDoc = formulaService.preprocess(decompressedForm),
            formObj = xjService.xmlDocToJs(formDoc);
        
        return formObj;
    }

    compressForm(formObj){
        
        const formXML = xjService.xmlToString( formulaService.postProcess( formObj ) );
        this._formXML = zLib.compressForm(formXML);
    }

    //PF-9500 set default font from account details in new forms
    setDefaultFont(){

        const defaultFont = listService.accountSettings.DefaultFontSelected || "verdana";
        const form = this.decompressForm();
        const themeProps = form.Form.Theme.Properties;
        const themeFonts = Object.keys(themeProps).filter((key) => key.toLowerCase().includes("font"));
        
        _.each(themeFonts, (font) => {
            let f = themeProps[font].trim().split(",");
            f[0] = defaultFont;
            themeProps[font] = f.join(",");
        });

        this.compressForm(form);
    }

    //===========================================================================================
    // This method creates a new form on the host.
    //
    // The name of the form will be "New Form", unless a form of that name exists for this user.
    // In that case the name is "New Form (n)" where 'n' is the highest member of an increasing
    // sequence of 'n'.
    //
    // Return  object: name/value pairs for keys: FormId, Name, GroupId, GroupName
    //
    //===========================================================================================
    newForm(newFormObjectParameters,selectedGroupType,selectedNodeOnTree,selectedNodeTarget
            ) {
        let defaultObjectParameters={
          groupType:constants.FORMS_PRIVATE_GROUP_TYPE,
          groupId:constants.DEFAULT_GROUP_ID,
          formName:constants.DEFAULT_FORM_NAME,
          formXML:this.defaultForm,
          isPrivate:true
        };

        let parametersToSend=Object.assign({},defaultObjectParameters,newFormObjectParameters);
        console.log("PArams to send New Form",parametersToSend);
        // Form name becomes "New Form" or "New Form (n)"

        return new Promise((resolve, reject) => {
            this.persistForm(parametersToSend).then(result => {
                let formId = result.formId;
                undoService.add({
                    undo: () => {
                        restService.deleteForm(formId).then(response => {
                        eventBus.trigger('deletingForm', formId); });

                    },
                    redo: ()=>{
                        this.unDeleteForm(result.formId, result.name, parametersToSend.groupId, parametersToSend.groupType,selectedGroupType,selectedNodeOnTree,selectedNodeTarget);
                    }
                }, textConstants.UNDO_NEW_FORM);
                resolve(result);
            }).catch(reject);
        });

    }

    unDeleteForm(formId, formName, groupId, groupType,selectedGroupType,selectedNodeOnTree,selectedNodeTarget){
        

        return restService.unDeleteForm(formId).then( data => {
            if (listService.activeDashboardTab === 'forms'){
              eventBus.trigger(constants.EV_OPEN_UNDELETED_FORM_DETAILS, formId, formName, groupType, groupId,selectedGroupType,selectedNodeOnTree,selectedNodeTarget);
            }
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    persistForm(formDTO){
        return new Promise((resolve, reject) => {

            // Build request
            // Carry out request
            restService.addForm(formDTO).then(data => {

                // Set success banner message for use by caller.
                const goodMsg = `App "${data.Name}", ID "${data.FormId}" created.`;
                const itemId = data.GroupId +'-' + data.FormId;
                let result = {  msg: goodMsg, formId: data.FormId, name: data.Name,
                    groupType: data.GroupId, itemId: itemId  };
                resolve(result);

            }, err => {
                console.log(err);
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });

        });

    }

}

const formAddService = new FormAddService();
export default formAddService;
